import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "components/bootstrap";
import { SelectedRowsProvider, useSelectedRows } from "common/contexts";
import { Row } from "common/components";
import EventProcedureStepLibraryList from "./List";
const Buttons = ({ onClose, onAdd }) => {
  const { t } = useTranslation("enterprise_security_events");
  const selectedRows = useSelectedRows();
  const selectedSteps = useMemo(
    () => selectedRows.map((step) => {
      delete step.type;
      return step;
    }),
    [selectedRows]
  );
  return /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, t("step_library_form.cancel")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", disabled: selectedRows.length < 1, onClick: () => onAdd(selectedSteps) }, t("step_library_form.add_steps")));
};
function EventProcedureStepLibraryForm({ selectedSteps, onClose, onAdd }) {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, bsSize: "lg", isConfirmDialog: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("step_library_form.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(EventProcedureStepLibraryList, { selectedSteps })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Buttons, { onClose, onAdd }))));
}
export default EventProcedureStepLibraryForm;
